import React from 'react';
import { FaImage, FaVideo } from 'react-icons/fa';
import './AddVideoModal.css';
import Input from '../../../components/Input/Input';

const AddVideoModal = ({
  showModal,
  isEditMode,
  selectedVideoThumbnail,
  setSelectedVideoThumbnail,
  selectedVideoFile,
  setSelectedVideoFile,
  existingVideoUrl,
  isNewThumbnail,
  setIsNewThumbnail,
  isNewVideo,
  setIsNewVideo,
  handleThumbnailFileChange,
  handleVideoFileChange,
  saveLoading,
  onSave,
  onClose,
  videoUrl,
  setVideoUrl
}) => {
  if (!showModal) return null;

  // Determine which thumbnail to show
  const displayThumbnail = selectedVideoThumbnail;
  const hasThumbnail = displayThumbnail;

  // Determine which video to show
  const getVideoSource = () => {
    if (selectedVideoFile) {
      return URL.createObjectURL(selectedVideoFile);
    } else if (existingVideoUrl) {
      return existingVideoUrl;
    }
    return null;
  };
  const hasVideo = selectedVideoFile || existingVideoUrl;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content add-edit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{isEditMode ? 'Edit Video' : 'Add Video'}</h3>
          <button
            type="button"
            className="modal-close"
            onClick={onClose}
            aria-label="Close"
            disabled={saveLoading}
          >
            ×
          </button>
        </div>

        <div className="profile-form">
          <div className="form-group">
            <Input
              type="url"
              title="URL"
              placeholder="Enter URL"
              value={videoUrl || ''}
              onChange={(e) => setVideoUrl(e.target.value)}
              className="video-form-input"
            />
          </div>

          {/* Video Thumbnail Section */}
          <div className="form-group">
            <label className="form-label">Video Thumbnail <span style={{ color: 'red' }}>*</span></label>
            <div
              className="upload-area"
              onClick={() => document.getElementById(isEditMode ? 'edit-video-thumbnail-input' : 'video-thumbnail-input').click()}
            >
              <input
                id={isEditMode ? 'edit-video-thumbnail-input' : 'video-thumbnail-input'}
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleThumbnailFileChange}
                required
              />
              {!hasThumbnail ? (
                <div className="upload-placeholder">
                  <FaImage />
                  <p>Click to select thumbnail or drag and drop</p>
                  <span>Supports: JPG, PNG, JPEG, WebP (Max 40MB)</span>
                </div>
              ) : (
                <div className="image-preview-container">
                  <img src={displayThumbnail} alt="Thumbnail Preview" className="image-preview" />
                </div>
              )}
            </div>
          </div>

          {/* Video Section */}
          <div className="form-group">
            <label className="form-label">Video <span style={{ color: 'red' }}>*</span></label>
            <div
              className="upload-area"
              onClick={() => document.getElementById(isEditMode ? 'edit-video-upload-input' : 'video-upload-input').click()}
            >
              <input
                id={isEditMode ? 'edit-video-upload-input' : 'video-upload-input'}
                type="file"
                accept="video/mp4,video/webm,video/quicktime,.mp4,.webm,.mov"
                style={{ display: "none" }}
                onChange={handleVideoFileChange}
                required
              />
              {!hasVideo ? (
                <div className="upload-placeholder">
                  <FaVideo />
                  <p>Click to select video or drag and drop</p>
                  <span>Supports: MP4, WebM, MOV (Max 40MB)</span>
                </div>
              ) : (
                <div className="video-preview-container">
                  <video
                    src={getVideoSource()}
                    controls
                    className="video-preview"
                  />
                </div>
              )}
            </div>
          </div>

          <div className="form-actions">
            <button type="button" onClick={onSave} disabled={saveLoading} aria-busy={saveLoading}>
              {saveLoading ? isEditMode ? 'Updating...' : 'Uploading...' : isEditMode ? 'Update' : 'Upload'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddVideoModal;

